const ChevronIcon = ({ viewBox = "0 0 24 24", className = "hayley-h-6 hayley-w-6 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};

export default ChevronIcon;
